import Link from "next/link";

import { Anchor, Button } from "@newsela/angelou";
import {
  actionPrefixes,
  objectTypes,
  withTrackEvent,
  actionNames,
} from "@newsela/snitch";

import useSignInUrl from "@/users/useSignInUrl";
import { anchorCss } from "../ViewPageError.style";

const AnchorWithTrackEvent = withTrackEvent(Anchor);

const SignInCta = () => {
  const signInUrl = useSignInUrl();

  const eventProperties = {
    objectType: objectTypes.user,
    actionPrefix: actionPrefixes.initiate,
    actionName: actionNames.navigate,
    streamProperties: {
      description: "Navigate to Log In page from View page",
    },
  };

  return (
    <Link href={signInUrl} passHref legacyBehavior>
      <AnchorWithTrackEvent
        __cssFor={{ root: anchorCss }}
        styleAnchorAsButton={{
          flavor: Button.flavors.primary,
        }}
        dataProps={{ "data-qa-selector": "log_in_cta" }}
        {...eventProperties}
      >
        Log in
      </AnchorWithTrackEvent>
    </Link>
  );
};

export default SignInCta;
